export const INITIAL_ARROWS_AI_TOOLS = [
  {
    id: 'add_contact_note',
    title: 'Add Contact Note',
    description: 'Add a note to a contact profile',
    icon: 'note-add',
  },
  {
    id: 'add_private_note',
    title: 'Add Private Note',
    description: 'Add a private note to a conversation (internal only)',
    icon: 'eye-off',
  },
  {
    id: 'update_priority',
    title: 'Update Priority',
    description: 'Update conversation priority level',
    icon: 'exclamation-triangle',
  },
  {
    id: 'add_label_to_conversation',
    title: 'Add Label to Conversation',
    description: 'Add a label to a conversation',
    icon: 'tag',
  },
  {
    id: 'faq_lookup',
    title: 'FAQ Lookup',
    description: 'Search FAQ responses using semantic similarity',
    icon: 'search',
  },
  {
    id: 'resolve_conversation',
    title: 'Resolve Conversation',
    description: 'Resolve a conversation when the issue has been addressed',
    icon: 'checkmark',
  },
  {
    id: 'handoff',
    title: 'Open conversation',
    description: 'The bot stops replying so a person can take over',
    icon: 'user-switch',
  },
  {
    id: 'assign_team',
    title: 'Assign Team',
    description: 'Assign the conversation to a team',
    icon: 'users',
  },
  {
    id: 'assign_agent',
    title: 'Assign Agent',
    description: 'Assign the conversation to an inbox agent',
    icon: 'user',
  },
  {
    id: 'send_message',
    title: 'Send Message',
    description: 'Send an exact text to the customer',
    icon: 'chat',
  },
  {
    id: 'send_resource',
    title: 'Send Resource',
    description: 'Send a library file to the customer on WhatsApp',
    icon: 'image',
  },
];

const KNOWN_IDS = new Set(INITIAL_ARROWS_AI_TOOLS.map(item => item.id));

const TITLE_TO_ID = {
  'add contact note': 'add_contact_note',
  'add private note': 'add_private_note',
  'update priority': 'update_priority',
  'add label to conversation': 'add_label_to_conversation',
  'faq lookup': 'faq_lookup',
  'resolve conversation': 'resolve_conversation',
  'handoff to human': 'handoff',
  'assign team': 'assign_team',
  'assign agent': 'assign_agent',
  'send resource': 'send_resource',
  'send message': 'send_message',
  'open conversation': 'handoff',
};

const toolI18nId = tool => {
  const raw = String(tool.slug || tool.id || '').toLowerCase();
  if (KNOWN_IDS.has(raw)) return raw;

  return (
    TITLE_TO_ID[raw] ||
    TITLE_TO_ID[String(tool.title || '').toLowerCase()] ||
    raw
  );
};

export const localizeArrowsAiTools = (tools, t, te) =>
  tools.map(tool => {
    const id = toolI18nId(tool);
    const titleKey = `ARROWS_AI.BUILTIN_TOOLS.${id}.TITLE`;
    const descriptionKey = `ARROWS_AI.BUILTIN_TOOLS.${id}.DESCRIPTION`;

    return {
      ...tool,
      title: te(titleKey) ? t(titleKey) : tool.title,
      description: te(descriptionKey) ? t(descriptionKey) : tool.description,
    };
  });
